import { FooterLinks } from 'components/FooterWrapper/components/Footer/utils';
import { CONTACT_US_ROUTE } from 'data/global';

export const links: FooterLinks[] = [
  {
    label: 'contactUs',
    href: CONTACT_US_ROUTE,
  },
  {
    label: 'terms&Conditions',
    href: '/terms-and-conditions',
  },
  {
    label: 'privacy',
    href: '/privacy-policy',
  },
];
